const components = document.querySelectorAll('[data-module="video"]');

class Video {
    constructor(component) {
        this.component = component;
        this.player = component.querySelector('[data-video-player]');
        this.buttons = component.querySelectorAll('[data-video-play]');

        if (!this.player || component.dataset.videoInitialized === 'true') {
            return;
        }

        component.dataset.videoInitialized = 'true';

        this.buttons.forEach((button) => {
            button.addEventListener('click', () => this.play());
        });
    }

    play() {
        const existingFrame = this.player.querySelector('iframe');

        if (existingFrame) {
            existingFrame.focus();
            return;
        }

        const frame = document.createElement('iframe');
        frame.title = this.player.dataset.videoTitle;
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        frame.src = this.player.dataset.videoSrc;

        this.player.replaceChildren(frame);
        this.player.classList.remove('hidden');
        this.buttons.forEach((button) => {
            button.hidden = true;
            button.classList.add('hidden');
        });

        this.component.querySelector('[data-video-fallback]')?.classList.remove('hidden');
        frame.focus();
    }
}

components.forEach((component) => {
    new Video(component);
});

export default Video;
